<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left" :style="{ visibility: render ? 'visible' : 'hidden' }">
        <span STYLE="font-size: 12px;">{{this.des}}</span>
      </div>
      <div class="title-right">
        <span STYLE="font-size: 12px;color:#FF0000;">注意：当前功能仅为发薪前工资条条数据预览，发薪后您可以在「订单中心」预览准确的工资条数据。</span>
        <el-button plain class="button-v2" @click="$back">{{ $t('back') }}</el-button>
      </div>
    </div>
    <!--<div class="title-box" >-->
      <!--<div class="title-left" :style="{ visibility: render ? 'visible' : 'hidden' }">-->
        <!--<select-cus @change="cusChange"></select-cus>-->
        <!--<div class="date-picker-v2" :class="{ ml16: cusListTotal.length > 1 }">-->
          <!--<el-date-picker class="query-date-picker" v-model="wageMonthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" :start-placeholder="$t('from')" :end-placeholder="$t('to')" @change="getData"></el-date-picker>-->
        <!--</div>-->
        <!--<div class="select-v2">-->
          <!--<el-select class="query-select" v-model="queryParams.idCards" multiple collapse-tags :placeholder="$t('selectStaff')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange">-->
            <!--<el-option v-for="item in dictData.emp" :key="item.id" :value="item.idCard" :label="item.empName" />-->
          <!--</el-select>-->
        <!--</div>-->
        <!--<div class="select-v2">-->
          <!--<el-select class="query-select" v-model="queryParams.costCenters" multiple collapse-tags :placeholder="$t('selectCostCenter')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange">-->
            <!--<el-option v-for="item in dictData.costCenter" :key="item.id" :value="item.costName" :label="item.costName" />-->
          <!--</el-select>-->
        <!--</div>-->
        <!--<div class="select-v2">-->
          <!--<bsp-dicts-select class="query-select" v-model="queryParams.taxTypes" multiple collapse-tags :placeholder="$t('selectTaxType')" filterable clearable @selectChange="handleSelectChange" @visible-change="handleSelectVisibleChange" :optionsList="dictData.taxType" v-if="dictData.taxType.length"></bsp-dicts-select>-->
        <!--</div>-->
        <!--<div v-if="false" class="date-picker-v2">-->
          <!--<el-date-picker v-model="queryParams.wageMonths" type="months" format="yyyy-MM" value-format="yyyy-MM" :placeholder="$t('salaryMonth')" prefix-icon="none" @change="getData"></el-date-picker>-->
          <!--<img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="title-right">-->
        <!--<el-button plain class="button-v2" @click="customHeaderModalShow = true">{{ $t('displayItemConfiguration') }}</el-button>-->
        <!--<el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleExport">{{ $t('export') }}</el-button>-->
        <!--<el-button plain class="button-v2" @click="$back">返回</el-button>-->
      <!--</div>-->
    <!--</div>-->

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          v-show="render"
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          :show-operation="true"
          align="center"
          :columns="columns"
          :data="tableData"
          show-footer
          :footer-method="footerMethod"
          @change-filter="changeFilter"
          :operation-column-width="240"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="previewWechatShow(row)">{{ $t('previewWechatPayslip') }}</span>
            
            <div class="divider ml10 mr10" v-if="row.canViewEmailSlip===undefined|| row.canViewEmailSlip!='0'"></div>
            <span class="text-button" v-if="row.canViewEmailSlip===undefined|| row.canViewEmailSlip!='0'" @click="previewEmailShow(row)">{{ $t('previewEMailPayslip') }}</span>
          </div>
        </template>
        
      </air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="getData" @page-size-change="pageSizeChange" show-page-size></bsp-pagination>
    </div>

    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('displayItemConfiguration')"
      :visible.sync="customHeaderModalShow"
      top="1vh"
    >
      <customHeader :header-list.sync="headerList" report-type="员工收入明细表"></customHeader>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="customHeaderModalShow = false">{{ $t('cancel') }}</el-button>
        <div class="flex acenter">
          <el-button type="primary" class="button-v2" :loading="submitLoading" @click="saveCustomHeader">{{ $t('save') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-drawer
      class="drawer-v2"
      title="微信工资条预览"
      :visible.sync="previewWechatShowFlag"
      :wrapper-closable="false"
      size="600px"
    >
      <div class="air-drawer-container">
        <div class="air-drawer-body grid center">
          <preview-wechat :data="wechatData"></preview-wechat>
        </div>
        <div class="air-drawer-footer flex jend acenter">
          <el-button type="primary" class="button-v2" @click="previewWechatShowFlag = false">{{ $t('determine') }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import * as api from '@/api/wage/payslip'
import previewEmail from '@/views/v2/service-process/order/components/preview-email'
import previewWechat from '@/views/v2/service-process/order/components/preview-wechat'
import {queryEmpInfoListPage} from '@/api/v2/common'
import exportMethod from '@/util/export'
import customHeader from '@/components/v2/custom-header'
import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
import BspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
import {updataCustHeaderInfo} from '@/api/wage/pay'
import { mapGetters } from 'vuex';
import { floatSumArray } from '@/util/util';
import { validatenull } from '@/util/validate';


export default {
  name: 'EmpIncomeDetail',
  components: {
    customHeader,
    SelectCus,
    BspDictsSelect,
    previewEmail,
    previewWechat
  },
  data() {
    return {
      render: false,
      loading: true,
      wageMonthRange: [],
      isSelectChange: false,
      des:'',
      queryParams: {
        cusId:'',
        batchId:'',
        startDate: undefined,
        endDate: undefined,
        idCards: [],
        costCenters: [],
        taxTypes: [],
        // wageMonths: [],
        cusIds: [],
        page: 1,
        limit: 20,
        total: 0
      },
      limitCustom: 1,
      dictMap: {},
      dictData: {
        emp: [],
        costCenter: [],
        taxType: []
      },
      columns: [],
      tableData: [],
      submitLoading: false,
      customHeaderModalShow: false,
      headerList: [],
      previewEmailShowFlag: false,
      emailData: {},
      previewWechatShowFlag: false,
      wechatData: {}
    }
  },
  computed: {
    ...mapGetters(['cusListTotal'])
  },
  created() {
    const storeParams = this.$getStore('empIncomeDetail_queryParams')
    if (storeParams) {
      // 如果缓存中有参数，则说明是从汇总点击查看明细而来
      this.queryParams = storeParams
      this.$removeStore('empIncomeDetail_queryParams')
    }
    this.init()
  },
  methods: {
    init() {
      this.queryParams.cusId = this.$userInfo.cusId
      this.queryParams.batchId = this.$route.query.batchId
      this.des = this.$route.query.des
      this.getEmpList()
      this.getData()
    },
    getData(val) {
      this.render = false
      this.loading = true
      if (this.$isNotEmpty(this.wageMonthRange)) {
        this.queryParams.startDate = this.wageMonthRange[0]
        this.queryParams.endDate = this.wageMonthRange[1]
      } else {
        this.queryParams.startDate = undefined
        this.queryParams.endDate = undefined
      }
      api.selectUnpayDataForSalaryDetail(this.queryParams).then(res => {
        const data = res.data.data
        data.customList.forEach(item => {
          item.minWidth = 140
          if (item.field === 'empName' || item.field === 'identityNum' || item.field === 'idCard') {
            item.fixed = 'left'
            item.filterType = 'input'
          }
        })
        this.columns = data.customList
        data.translates.forEach(item => {
          if(item.dictMap!=undefined) {
            this.dictMap[item.field] = this.$arrayToObj(item.dictMap, 'codeItemId')
          }
        })
        if (!this.dictMap.taxType) {
          this.dictMap.taxType = this.$arrayToObj(data.taxType, 'codeItemId')
        }
        this.tableData = this.$handleTableDict(data.dataList, this.dictMap, '')
        this.queryParams.total = data.params.total
        this.dictData.costCenter = data.costCenter
        this.dictData.taxType = data.taxType
        this.render  = true
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    getEmpList() {
      queryEmpInfoListPage({cusId: this.$userInfo.cusId, limit: 100000}).then(res => {
        this.dictData.emp = res.data.records
      })
    },
    handleSelectChange(val) {
      if (this.$isEmpty(val)) {
        // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
        this.getData()
        this.isSelectChange = false
      } else {
        this.isSelectChange = true
      }
    },
    handleSelectVisibleChange(val) {
      // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
      if (!val && this.isSelectChange) {
        this.getData()
        // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
        this.isSelectChange = false
      }
    },
    saveCustomHeader() {
      if (this.$isEmpty(this.headerList)) {
        this.$msgError('显示项目不能为空')
        return
      }
      let param = {
        headers: this.headerList,
        reportType: '员工收入明细表'
      }
      this.submitLoading = true
      updataCustHeaderInfo(param).then(res => {
        if (res.data.code === 0) {
          this.customHeaderModalShow = false
          this.$msgSuccess('保存成功')
          this.getData()
        }
      }).finally(() => this.submitLoading = false)
    },
    handleExport() {
      this.$msgInfo(`${ this.$t('startDownloading') }...`);
      exportMethod({
        columns: this.$clone(this.columns),
        beanName: 'salaryHistoryServiceImpl',
        methodName: 'selectUnpayDataForSalaryDetailForExport',
        headerType: '1003',
        headerRowNum: 1,
        isSort: true,
        fileName: "员工收入明细表.xls",
        ...this.queryParams,
        type: 'excel'
      }, '/wage', true)
    },
    // 客户筛选change事件
    cusChange({ data, checkedLabels, checkedValues }) {
      this.queryParams.cusIds = checkedValues;
      this.getData();
    },
    numToArray(list, field) {
      return list.map(item => {
        return validatenull(item[field]) ? 0 : item[field];
      })
    },
    sumNum (list, field) {
      const numArray = this.numToArray(list, field);
      return floatSumArray(numArray);
    },
    footerMethod ({ columns, data }) {
      let _this = this;
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return '合计';
          } else {
            if (!validatenull(column.params)) {
              const { valueType } = column.params;
              if (valueType == '92420001' || valueType == '92420002') {
                return this.sumNum(data, column.property)
              }
              return null
            } else {
              return null
            }
          }
        })
      ]
    },
    // 输入框回车，调接口
    pageSizeChange(val) {
      this.queryParams = Object.assign(val);
      this.getData();
    },
    async previewEmailShow(row) {
      this.$go_blank('/biz/salarySheetView', {
         salaryDetailId:row.id
      })
    },
    previewWechatShow(row) {
        api.previewUnPaySlipPhone({
          month: row.wageMonth,
          empId: row.empId,
          detailId: row.id
        }).then(res => {
          if (res.data.code === 0) {
          for (const group of res.data.data.dataList) {
            for (const item of group.itemList) {
              if (item.name.includes('实发')) {
                this.$set(this.wechatData, 'netPay', item.money)
                break
              }
            }
          }
          this.$set(this.wechatData, 'wageMonth', row.wageMonth)
          this.$set(this.wechatData, 'list', res.data.data.dataList)
          this.previewWechatShowFlag = true
        }
      })
    },
  }
}
</script>
